export default "__VITE_ASSET__CLERUal0__"